import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './CollapsedPanelValues.css';
import Icon, { IconSizes } from '../foundations/Icon';

export const MAX_VISIBLE_VALUES = 10;

const CollapsedPanelValues = ({
    values,
    itemClassName,
    containerClassName,
    onDelete,
    shouldSliceValues = false,
    isReadOnly = false,
}) => {
    const visibleValues = shouldSliceValues ? values.slice(0, MAX_VISIBLE_VALUES) : values;
    const remainingCount = values.length - MAX_VISIBLE_VALUES;

    return (
        <div className={classNames(css.collapsedContentContainer, containerClassName)}>
            {visibleValues.map(value => (
                <div key={`collapsed_${value}`} className={classNames(css.collapsedItem, itemClassName)}>
                    {value}
                    {onDelete && !isReadOnly && (
                        <Icon name="x" size={IconSizes.X_SMALL} onClick={() => onDelete(value)} />
                    )}
                </div>
            ))}
            {shouldSliceValues && remainingCount > 0 && (
                <div className={classNames(css.collapsedItem, css.moreItem)}>+{remainingCount} more</div>
            )}
        </div>
    );
};

CollapsedPanelValues.propTypes = {
    values: PropTypes.array.isRequired,
    itemClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    onDelete: PropTypes.func,
    shouldSliceValues: PropTypes.bool,
    isReadOnly: PropTypes.bool,
};

export default CollapsedPanelValues;
